import React, { useContext, useState } from 'react';
import PageTitle from '../../components/common/PageTitle';
import { CenteredLayout } from '../../components/layouts';
import AdminNavbar from '../../components/layouts/AdminNavbar';
import { userRoleEnum } from '../../utils/enums';
import UserContext from '../AppRouter/UserContext';
import useExpectedHours from '../../hooks/useExpectedHours'; 
import ExpectedHoursList from '../../components/layouts/ExpectedHoursList';
import { monthNames } from '../../utils/consts';

const HoursChecker: React.FC = () => {
  const [selectedMonth, setSelectedMonth] = useState<string>(monthNames[new Date().getMonth()]);
  const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear());

  const { 
    expectedHours, 
    getExpectedHours, 
    isLoading,
    acceptSettlement,
    rejectSettlement 
  } = useExpectedHours(selectedMonth, selectedYear);
  const { userData } = useContext(UserContext);

  return (
    <>
      {userData.data.baseRole === userRoleEnum.Admin && <AdminNavbar />}
      <CenteredLayout>
        <PageTitle title="Rozliczenie godzin usług" />
        <div className="table-container">
          <ExpectedHoursList
            tableHeadTxt="Rozliczenie godzin usług"
            isLoading={isLoading}
            getMoreItems={getExpectedHours}
            items={expectedHours}
            selectedMonth={selectedMonth}
            selectedYear={selectedYear}
            setSelectedMonth={setSelectedMonth}
            setSelectedYear={setSelectedYear}
            acceptSettlement={acceptSettlement}
            rejectSettlement={rejectSettlement}
          />
        </div>
      </CenteredLayout>
    </>
  );
};

export default HoursChecker;
